import type { dePlatform } from './de.platform';

/** Sistem yönetimi metinleri. Referans: de.platform.ts */
export const trPlatform: Record<keyof typeof dePlatform, string> = {
  'platform.nav.tenants': 'Müşteriler',
  'platform.nav.settings': 'Ayarlar',
  'platform.nav.main': 'Ana menü',
  'platform.role': 'Sistem yönetimi',

  'platform.tenants.title': 'Müşteriler',
  'platform.tenants.empty': 'Henüz kayıtlı müşteri yok.',
  'platform.tenants.customer': 'Müşteri',
  'platform.tenants.email': 'E-posta',
  'platform.tenants.registered': 'Kayıt tarihi',
  'platform.tenants.status': 'Durum',
  'platform.tenants.callers': 'Temsilciler',
  'platform.tenants.campaigns': 'Kampanyalar',
  'platform.tenants.balance': 'Bakiye',
  'platform.tenants.price': 'Dakika ücreti',
  'platform.tenants.minutes': 'Dakika',
  'platform.tenants.open': 'Aç',
  'platform.tenants.paymentsLater': 'Ödenen yüklemeler ve verilen bonus bakiye ödeme bölümüyle gelecek.',

  'platform.status.active': 'Etkin',
  'platform.status.suspended': 'Engelli',
  'platform.status.deleted': 'Silinmiş',

  'platform.tenant.back': 'Müşterilere dön',
  'platform.tenant.account': 'Hesap',
  'platform.tenant.customerNumber': 'Müşteri numarası',
  'platform.tenant.accountName': 'Firma / hesap adı',
  'platform.tenant.owner': 'Hesap sahibi',
  'platform.tenant.language': 'Dil',
  'platform.tenant.suspend': 'Hesabı engelle',
  'platform.tenant.unsuspend': 'Hesabı serbest bırak',
  'platform.tenant.suspendTitle': 'Hesabı engelle',
  'platform.tenant.suspendText':
    'Süren tüm görüşmeler hemen sona erer, tüm kullanıcıların oturumu kapatılır ve yeniden giriş yapamazlar. Hesabı istediğiniz zaman yeniden açabilirsiniz.',

  'platform.tenant.usage': 'Kullanım',
  'platform.tenant.balance': 'Bakiye',
  'platform.tenant.balanceAdd': 'Bakiye ekle',
  'platform.tenant.balanceSubtract': 'Bakiye düş',
  'platform.tenant.balanceAmount': 'Euro cinsinden tutar',
  'platform.tenant.balanceNote': 'Gerekçe - müşteri görür',
  'platform.tenant.balanceNotePlaceholder': 'örn. arıza nedeniyle jest',
  'platform.tenant.balanceBookings': 'Son kayıtlar',
  'platform.tenant.balanceEmpty': 'Henüz kayıt yok.',
  'platform.tenant.balanceAvailable': 'Kullanılabilir',
  'platform.tenant.balanceDebitTitle': 'Bakiye düş',
  'platform.tenant.balanceDebitText':
    'Tutar hemen düşülür. Gerekçe müşterinin ödeme geçmişinde görünür.',
  'platform.tenant.balanceDebitConfirm': 'Şimdi düş',
  'platform.tenant.balanceInternalNote': 'Dahili not',
  'platform.tenant.usageMinutes': 'Faturalanan dakika',
  'platform.tenant.usageToday': 'Bugünkü dakika',
  'platform.tenant.usageConnected': 'Bağlanan görüşme',
  'platform.tenant.usageAttempts': 'Arama denemesi',
  'platform.tenant.usageLast': 'Son görüşme',

  'platform.tenant.export': 'Müşteri verisi aktarımı',
  'platform.tenant.exportHint':
    'Kampanya başına bir CSV içeren tek ZIP dosyası. Her kampanyanın kendi alanları vardır, bu yüzden kampanya başına bir dosya.',
  'platform.tenant.exportAction': 'Tüm müşteri verilerini indir',
  'platform.tenant.exportScope':
    'Normal kayıtlar dahildir. Arşivlenmiş ve müşteri tarafından silinmiş veriler arşivde bulunur.',

  'platform.tenant.settings': 'Müşteri ayarları',
  'platform.tenant.settingsHint': 'Burada yalnızca görüntülenir - müşteri kendisi değiştirir.',
  'platform.tenant.settingsCountries': 'Ülke kodları',
  'platform.tenant.settingsInbound': 'Gelen çağrılı kampanyalar',
  'platform.tenant.settingsQueue': 'Bekleme sıralı kampanyalar',
  'platform.tenant.settingsRecording': 'Kayıtlı kampanyalar',

  'platform.tenant.archive': 'Arşiv ve silme',
  'platform.tenant.archiveSoon':
    'Müşteri tarafından silinen verilerin arşivi ve kalıcı silme sonraki adımlardan birinde gelecek.',

  'platform.live.title': 'Süren görüşmeler',
  'platform.live.hint': 'Yalnızca gerçekten konuşulan görüşmeler.',
  'platform.live.empty': 'Bu müşteride şu anda görüşme yok.',
  'platform.live.campaign': 'Kampanya',
  'platform.live.caller': 'Temsilci',
  'platform.live.customer': 'Müşteri',
  'platform.live.duration': 'Süre',
  'platform.live.listen': 'Dinle',
  'platform.live.stopListening': 'Dinlemeyi bitir',
  'platform.live.listening': 'Dinliyorsunuz',
  'platform.live.silent':
    'Yalnızca dinleyebilirsiniz. Konuşmak mümkün değildir ve görüşmedeki kimse bundan haberdar olmaz.',

  'platform.recordings.title': 'Kayıtlar',
  'platform.recordings.hint': 'Kampanya bazında indirme. Kayıtlar 30 gün sonra kalıcı olarak silinir.',
  'platform.recordings.campaign': 'Kampanya',
  'platform.recordings.count': 'Mevcut',
  'platform.recordings.range': 'Dönem',
  'platform.recordings.download': 'Tümünü ZIP olarak',
  'platform.recordings.empty': 'Bu müşteri için kayıt bulunmuyor.',
  'platform.recordings.none': 'yok',
  'platform.recordings.notYet':
    'Görüşme kaydı işlevinin kendisi sonraki adımlardan birinde gelecek. O zamana kadar bu liste boş kalır.',

  'platform.period.today': 'Bugün',
  'platform.period.week': 'Hafta',
  'platform.period.month': 'Ay',
  'platform.period.all': 'Tümü',
  'platform.period.label': 'Dönem',
  'platform.period.help':
    'Sunucu saatine göre hesaplanır: bugün 00:00’dan, hafta pazartesi 00:00’dan, ay ayın birinden.',

  'platform.settings.title': 'Genel ayarlar',
  'platform.settings.price': 'Varsayılan dakika ücreti',
  'platform.settings.startCredit': 'Başlangıç bakiyesi',
  'platform.settings.minTopUp': 'En az yükleme tutarı',
  'platform.settings.minTopUpHint':
    'Yalnızca müşteri kendi bakiyesini yüklerken geçerlidir. Sizin kayıtlarınız için geçerli değildir.',
  'platform.settings.retryInterval': 'Yeniden denemeler arası en az süre (dakika)',
  'platform.settings.supportEmail': 'Destek e-postası',
  'platform.settings.saved': 'Ayarlar kaydedildi.',
  'platform.settings.smtpSoon': 'SMTP ayarları e-posta bölümüyle gelecek.',

  'error.tenant.not_found': 'Bu müşteri bulunamadı.',
  'error.call.not_found': 'Bu görüşme artık sürmüyor.',
  'error.monitoring.unavailable': 'Bu görüşme şu anda dinlenemiyor.',
  'error.recordings.invalid_period': 'Lütfen geçerli bir dönem seçin.',
  'error.auth.platform_admin_required': 'Bu bölüm kullanılamıyor.',
};
